/* ===========================================================================
   Black Betty BBQ - header dropdowns

   The theme opens these on pointerenter only, so on a phone or a tablet the
   two menus whose parent is href="#" (Menu, Gallery) do nothing at all when
   tapped. This adds tap, click and keyboard handling on top of the theme's
   hover behaviour, without replacing any of it: opening still means setting
   aria-expanded on the parent link, which is what the theme's own CSS reacts
   to, so hover keeps working exactly as before.
   =========================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var nav = document.querySelector('nav[header-menu]');
    if (!nav) return;

    var parents = nav.querySelectorAll('.menu-list__link[aria-haspopup="true"]');
    if (!parents.length) return;

    var coarse = window.matchMedia('(hover: none)').matches;

    function itemOf(link) { return link.closest('.menu-list__list-item'); }
    function panelOf(link) {
      var item = itemOf(link);
      return item ? item.querySelector('.menu-list__submenu') : null;
    }
    function linksIn(link) {
      var panel = panelOf(link);
      return panel ? panel.querySelectorAll('a[href]') : [];
    }

    function close(link) { link.setAttribute('aria-expanded', 'false'); }

    function closeAll(except) {
      Array.prototype.forEach.call(parents, function (p) {
        if (p !== except) close(p);
      });
    }

    function open(link) {
      closeAll(link);
      link.setAttribute('aria-expanded', 'true');
    }

    function isOpen(link) { return link.getAttribute('aria-expanded') === 'true'; }

    Array.prototype.forEach.call(parents, function (link) {
      link.setAttribute('aria-expanded', 'false');
      var dead = (link.getAttribute('href') || '#') === '#';

      link.addEventListener('click', function (e) {
        // A parent that goes nowhere should open its menu instead of jumping
        // to the top of the page. A parent that does go somewhere still goes
        // there on a mouse - but on touch the first tap opens it, because
        // otherwise the children are unreachable.
        if (dead || coarse) {
          if (!isOpen(link)) {
            e.preventDefault();
            open(link);
            return;
          }
          if (dead) { e.preventDefault(); close(link); }
        }
      });

      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          open(link);
          var first = linksIn(link)[0];
          if (first) first.focus();
        } else if (e.key === 'Escape') {
          close(link);
        }
      });

      var panel = panelOf(link);
      if (!panel) return;

      panel.addEventListener('keydown', function (e) {
        var items = Array.prototype.slice.call(linksIn(link));
        var i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var step = e.key === 'ArrowDown' ? 1 : -1;
          var next = items[(i + step + items.length) % items.length];
          if (next) next.focus();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          close(link);
          link.focus();
        } else if (e.key === 'Tab' && !e.shiftKey && i === items.length - 1) {
          close(link);
        }
      });
    });

    // A click anywhere else, or focus leaving the bar, puts them all away.
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('nav[header-menu]')) closeAll(null);
    });
    document.addEventListener('focusin', function (e) {
      if (!e.target.closest || !e.target.closest('nav[header-menu]')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  });
})();
